import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/light-arrow-up-white.svg'
import _imports_1 from '@/assets/img/light-arrow-up.svg'
import _imports_2 from '@/assets/img/light-arrow-down-white.svg'
import _imports_3 from '@/assets/img/light-arrow-down.svg'


const _withScopeId = n => (_pushScopeId("data-v-3c3eae09"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "item-parent"
}
const _hoisted_2 = { class: "dropdown-checkbox-circle-division" }
const _hoisted_3 = ["disabled", "checked"]
const _hoisted_4 = { class: "dropdown-item-text-division" }
const _hoisted_5 = { class: "dropdown-item-text-division-1" }
const _hoisted_6 = {
  key: 0,
  class: "button-arrows dropdown-button-arrow"
}
const _hoisted_7 = {
  key: 0,
  class: "dropdown-button-arrow"
}
const _hoisted_8 = {
  key: 0,
  class: "dropdown-button-arrow-img",
  src: _imports_0
}
const _hoisted_9 = {
  key: 1,
  class: "dropdown-button-arrow-img",
  src: _imports_1
}
const _hoisted_10 = {
  key: 1,
  class: "dropdown-button-arrow"
}
const _hoisted_11 = {
  key: 0,
  class: "dropdown-button-arrow-img",
  src: _imports_2
}
const _hoisted_12 = {
  key: 1,
  class: "dropdown-button-arrow-img",
  src: _imports_3
}
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectMultiLevelItems = _resolveComponent("SelectMultiLevelItems", true)!

  return (_ctx.displayNow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.searchVal === '' ? true : _ctx.list.canDisplay)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: _normalizeClass(["dropdown-item", _ctx.depthClassName]),
              href: "javascript:void(0)",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onClickItem($event)), ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("input", {
                  class: "checkbox-custom",
                  type: "checkbox",
                  disabled: _ctx.childList.length > 0 ? true : false,
                  checked: _ctx.isItemSelected ? true : false
                }, null, 8, _hoisted_3),
                _createElementVNode("label", {
                  for: "checkbox-1",
                  class: _normalizeClass(
            _ctx.allItemsSelected
              ? 'checkbox-custom-label'
              : _ctx.someItemsSelected && _ctx.isItemSelected
                ? 'checkbox-custom-label-disable'
                : 'checkbox-custom-label'
          )
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.list.name), 1),
                (_ctx.childList.length > 0 || null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      (_ctx.showChildren || null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_ctx.isItemSelected || null)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                              : (_openBlock(), _createElementBlock("img", _hoisted_9))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (_ctx.isItemSelected || null)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                              : (_openBlock(), _createElementBlock("img", _hoisted_12))
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.childList.length > 0 || null)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childList, (item, itemIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: itemIndex,
                  class: "dropdown-item-row-inner"
                }, [
                  (item !== '' || null)
                    ? (_openBlock(), _createBlock(_component_SelectMultiLevelItems, {
                        key: _ctx.depth + 1,
                        list: item,
                        depth: _ctx.depth + 1,
                        "question-id": _ctx.questionId,
                        "selected-items": _ctx.selectedItems,
                        "search-val": _ctx.searchVal,
                        "item-offset-val": _ctx.itemOffsetVal,
                        onSetMeCanDisplay: _ctx.setMeCanDisplay,
                        onSelectParentItem: _ctx.selectParentItem,
                        onUnselectParentItem: _ctx.unselectParentItem
                      }, null, 8, ["list", "depth", "question-id", "selected-items", "search-val", "item-offset-val", "onSetMeCanDisplay", "onSelectParentItem", "onUnselectParentItem"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 512)), [
              [_vShow, _ctx.showChildren]
            ])
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}